const title = "Privacy Policy – Team Banner Sports";
export {title}